import React from 'react';
import { Button } from 'antd';
import styled from '@emotion/styled';

interface ButtonActionPageProps {
  text?: string | React.ReactNode;
  icon?: React.ReactElement;
  id: string | number;
  bgWhite?: string;
  onClick?: () => void;
  htmlType?: string;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
}

export const ButtonActionPage = (props: ButtonActionPageProps) => {
  const { text, icon, id, bgWhite, onClick, className, htmlType, loading, disabled } = props;
  return (
    <StyledButton
      key={id}
      name={bgWhite}
      onClick={onClick}
      disabled={disabled}
      className={className}
      htmlType={htmlType}
      loading={loading}
    >
      {icon}
      <StyledSpan>{text}</StyledSpan>
    </StyledButton>
  );
};

const StyledButton = styled(Button)((props: any) => ({
  background: props.name ? props.theme.color.white : props.theme.color.black,
  color: props.name ? props.theme.color.black : props.theme.color.white,
  ...props.theme.pageHeader.button,
}));

const StyledSpan = styled.span`
  margin-left: 5px;
  padding: 1px;
`;
